import template from './agent-bonus-tooltip.html';
import tooltipTemplate from './tooltip.html';

export default angular.module('cian.agentBonusTooltip', ['ui.cian.tooltip'])
    .directive('agentBonusTooltip', ['$templateCache', function($templateCache) {
        $templateCache.put('agent-bonus-tooltip.html', tooltipTemplate);
        
        return {
            restrict: 'A',
            template,
            replace: true,
            transclude: true,
            scope: {
                agentBonusTooltip: '@?'
            },
        };
    }]);


// WEBPACK FOOTER //
// ./src/components/agent-bonus/agent-bonus-tooltip.js